// src/pages/DashboardEstoque.js
import React, { useContext, useState, useEffect } from "react";
import AdminLayout from "../components/AdminLayout";
import { AuthContext } from "../contexts/AuthContext";
import axios from "axios";
import WidgetItensDisponiveis from "../components/WidgetItensDisponiveis";
import WidgetMovimentosMensal from "../components/WidgetMovimentosMensal";
import ExpiringItemsTable from "../components/ExpiringItemsTable";

function DashboardEstoqueInfo() {
  const { user } = useContext(AuthContext);
  const [stats, setStats] = useState({
    totalItems: 0,
    movements: 0,
    newItems: 0,
    removedItems: 0,
  });
  const [lastEntries, setLastEntries] = useState([]);
  const [lastExits, setLastExits] = useState([]);
  const [availableItems, setAvailableItems] = useState([]);
  const [expiringItems, setExpiringItems] = useState([]);
  
  const [loadingStats, setLoadingStats] = useState(true);
  const [loadingLists, setLoadingLists] = useState(true);
  const [loadingAvailable, setLoadingAvailable] = useState(true);

  // Busca estatísticas do estoque
  useEffect(() => {
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}estoque/dashboard/`)
        .then((response) => {
          setStats(response.data);
          setLoadingStats(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar estatísticas do estoque:", error);
          setLoadingStats(false);
        });
    }
  }, [user]);

  // Busca as listas de últimas entradas e saídas
  useEffect(() => {
    if (user) {
      Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}estoque/ultimas-entradas/`),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}estoque/ultimas-saidas/`),
      ])
        .then(([entradasResponse, saidasResponse]) => {
          setLastEntries(entradasResponse.data.slice(0, 5));
          setLastExits(saidasResponse.data.slice(0, 5));
          setLoadingLists(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar listas de entradas e saídas:", error);
          setLoadingLists(false);
        });
    }
  }, [user]);

  // Busca os itens disponíveis para o widget
  useEffect(() => {
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}estoque/itens-disponiveis/`)
        .then((response) => {
          setAvailableItems(response.data);
          setLoadingAvailable(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar itens disponíveis:", error);
          setLoadingAvailable(false);
        });
    }
  }, [user]);

  // Busca todos os itens e filtra os que possuem data de validade para expiração
  useEffect(() => {
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}estoque/items/list/`)
        .then((response) => {
          // Filtra os itens que possuem a propriedade data_validade
          const itemsComValidade = response.data.filter(item => item.data_validade);
          setExpiringItems(itemsComValidade);
        })
        .catch((error) => {
          console.error("Erro ao carregar itens para expiração:", error);
        });
    }
  }, [user]);

  // Renderização condicional: garante que os Hooks sejam chamados incondicionalmente
  if (!user) {
    return (
      <AdminLayout>
        <div>Carregando usuário...</div>
      </AdminLayout>
    );
  }

  if (loadingStats) {
    return (
      <AdminLayout>
        <div>Carregando estatísticas...</div>
      </AdminLayout>
    );
  }

  return (
    <>
      {/* Cabeçalho do Dashboard */}
      <div
        className="page-header d-print-none"
        style={{ marginTop: "0px", paddingBottom: "18px" }}
      >
        <div className="row align-items-center">
          <div className="col">
            <h2 className="page-title">Dashboard Estoque</h2>
            <div className="text-muted mt-1">
              Resumo das atividades do estoque
            </div>
          </div>
        </div>
      </div>

      {/* Widgets de estatísticas agregadas */}
      <div className="row row-deck row-cards" style={{ marginTop: "0px", paddingBottom: "8px" }}>
        {/* Widget: Total de Itens */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Total de Itens</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a className="dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Geral
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Hoje</a>
                      <a className="dropdown-item" href="#">Semana</a>
                      <a className="dropdown-item" href="#">Mês</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">{stats.totalItems}</div>
              <div className="text-secondary">Itens em estoque</div>
            </div>
          </div>
        </div>



        {/* Widget: Novos Itens Adicionados */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Novos Itens</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a className="dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Hoje
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Hoje</a>
                      <a className="dropdown-item" href="#">Semana</a>
                      <a className="dropdown-item" href="#">Mês</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">{stats.newItems}</div>
              <div className="text-secondary">Itens adicionados</div>
            </div>
          </div>
        </div>

        {/* Widget: Itens Removidos */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Itens Despachados</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a className="dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Hoje
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Hoje</a>
                      <a className="dropdown-item" href="#">Semana</a>
                      <a className="dropdown-item" href="#">Mês</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">{stats.removedItems}</div>
              <div className="text-secondary">Saídas de estoque</div>
            </div>
          </div>
        </div>

        {/* Widget: Movimentos Realizados */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Movimentações</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a className="dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Geral
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Últimos 7 dias</a>
                      <a className="dropdown-item" href="#">Últimos 30 dias</a>
                      <a className="dropdown-item" href="#">Últimos 3 meses</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">{stats.movements}</div>
              <div className="text-secondary">Movimentos realizados</div>
            </div>
          </div>
        </div>


      </div>

      <ExpiringItemsTable expiringItems={expiringItems} />

      {/* Widgets: Últimas Entradas e Últimas Saídas */}
      {loadingLists ? (
        <div>Carregando listas de entradas e saídas...</div>
      ) : (
        <div className="row row-deck row-cards">
          {/* Widget: Últimas Entradas */}
          <div className="col-12 col-lg-4">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Últimas Entradas</h3>
              </div>
              <div className="list-group list-group-flush list-group-hoverable">
                {lastEntries.length === 0 ? (
                  <div className="list-group-item">
                    <div className="row align-items-center">
                      <div className="col text-center">Nenhuma entrada encontrada.</div>
                    </div>
                  </div>
                ) : (
                  lastEntries.map((item, index) => (
                    <div key={index} className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="badge bg-green"></span>
                        </div>
                        <div className="col-auto">
                          <a href="#">
                            <span className="avatar avatar-1">
                              {item.descricao ? item.descricao.charAt(0).toUpperCase() : "?"}
                            </span>
                          </a>
                        </div>
                        <div className="col text-truncate">
                          <a href="#" className="text-reset d-block">
                            {item.descricao}
                          </a>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            Quantidade: {Math.floor(item.quantidade)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Widget: Últimas Saídas */}
          <div className="col-12 col-lg-4">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Últimas Saídas</h3>
              </div>
              <div className="list-group list-group-flush list-group-hoverable">
                {lastExits.length === 0 ? (
                  <div className="list-group-item">
                    <div className="row align-items-center">
                      <div className="col text-center">Nenhuma saída encontrada.</div>
                    </div>
                  </div>
                ) : (
                  lastExits.map((item, index) => (
                    <div key={index} className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="badge bg-red"></span>
                        </div>
                        <div className="col-auto">
                          <a href="#">
                            <span className="avatar avatar-1">
                              {item.descricao ? item.descricao.charAt(0).toUpperCase() : "?"}
                            </span>
                          </a>
                        </div>
                        <div className="col text-truncate">
                          <a href="#" className="text-reset d-block">
                            {item.descricao}
                          </a>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            Quantidade: {Math.floor(item.quantidade)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
                
          {/* Widget: Itens Disponíveis */}
        {loadingAvailable ? (
            <div>Carregando itens disponíveis...</div>
        ) : (
            <WidgetItensDisponiveis items={availableItems} />
        )}
        {/* Widget gráfico de movimentos mensais */}
        <WidgetMovimentosMensal />
        </div>
      )}
    </>
  );
}

export default DashboardEstoqueInfo;